import { paymentClient } from "@core/clients";
import { SavePaymentCardArgs, SavePaymentCardResponse } from "@core/types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "../../../config/query-client";

type Options = UseMutationOptions<SavePaymentCardResponse, any, SavePaymentCardArgs, string[]>;

export default function useSavePaymentCardMutation(options?: Options) {
  return useMutation(
    ["save-payment-mutation"],
    async (args: SavePaymentCardArgs) => {
      return await paymentClient.savePaymentCard(args);
    },
    {
      onSuccess() {
        queryClient.invalidateQueries(["cards"]);
      },
      ...options,
    },
  );
}
